import React from "react";
import { Layout, Typography, Image } from "antd";
import CommonSidebar from "../../components/CommonSidebar";
import goalsImage from "../../assets/focus.jpg";

const { Title, Paragraph } = Typography;
const { Content } = Layout;

const GoalsObjectivesPage = () => {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Layout style={{ background: "#fff" }}>
        {/* Sidebar */}
        <CommonSidebar defaultSelectedKey="4" />

        {/* Main Content */}
        <Layout
          style={{
            background: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "start",
            padding: "20px 20px",
            flex: 1, 
          }}
        >
          <Content
            style={{
              width: "100%",
              maxWidth: "100%", 
            }}
          >
            {/* Image Section */}
            <div style={{ textAlign: "left", marginBottom: "30px" }}>
              <Image
                src={goalsImage}
                alt="Goals & Objectives"
                style={{
                  width: "100%",
                  borderRadius: "10px",
                }}
                preview={false}
              />
            </div>

            {/* Text Section */}
            <Typography>
            

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                At <strong>Yalla Nellab</strong>, our goals are rooted in the
                belief that sport can shape stronger individuals and more
                connected communities.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                <strong>Promoting Active Lifestyles</strong> <br />
                We aim to increase participation in physical activity across all
                age groups, encouraging movement, fitness and overall wellbeing
                through accessible sporting opportunities.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                <strong>Creating Inclusive Platforms</strong> <br />
                Our objective is to ensure that everyone — regardless of age,
                gender or ability — has the chance to compete, learn and grow
                in a safe and supportive environment.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                <strong>Developing Character and Discipline</strong> <br />
                Through organized sports and events, we promote teamwork,
                respect and discipline — values that extend beyond the field
                into everyday life.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                <strong>Empowering Youth and Nurturing Talent</strong> <br />
                We strive to identify and support young athletes, giving them
                the resources and guidance needed to develop their potential and
                pursue their sporting dreams.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                <strong>Strengthening Community Spirit</strong> <br />
                By bringing people together through sport, we aim to rebuild a
                sense of belonging and unity — reminding everyone that sport is
                not just about winning, but about connection, growth and shared
                joy.
              </Paragraph>
            </Typography>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default GoalsObjectivesPage;